module.exports = __webpack_public_path__ + "static/media/color-sharp2.83048ab8.png";